
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const ConditionsUtilisationPage = () => {
  return (
    <>
      <header>
        <h1 className="sr-only">Conditions d'utilisation - SARL ADF Biomédical Algérie</h1>
      </header>
      <Navbar />
      <main>
        {/* HERO SECTION */}
        <section className="relative pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <p className="text-sm text-text-secondary mb-6">
                <Link to="/" className="hover:text-[#E31B23] transition-colors cursor-pointer">Accueil</Link> / Conditions d'utilisation
              </p>
              <h2 className="text-5xl md:text-6xl font-bold text-text-primary mb-6">
                Conditions d'utilisation
              </h2>
              <p className="text-xl text-text-secondary max-w-3xl mx-auto">
                Règles d'utilisation du site adfbiomedical.dz
              </p>
            </motion.div>
          </div>
        </section>

        {/* CONTENU */}
        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="space-y-12"
            >
              {/* Introduction */}
              <div>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Les présentes conditions générales d'utilisation (ci-après "CGU") régissent l'accès et l'utilisation du site web adfbiomedical.dz (ci-après "le Site") édité par SARL ADF Biomédical.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    En accédant et en utilisant ce Site, vous acceptez sans réserve les présentes CGU. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser ce Site.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Date de dernière mise à jour :</strong> Janvier 2025
                  </p>
                </div>
              </div>

              {/* Objet */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-file-text-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Objet
                </h3>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Les présentes CGU ont pour objet de définir les modalités et conditions d'utilisation du Site ainsi que les droits et obligations des parties dans ce cadre. Elles sont accessibles à tout moment sur le Site et prévaudront, le cas échéant, sur toute autre version ou tout autre document contradictoire.
                  </p>
                </div>
              </div>

              {/* Accès au site */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-door-open-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Accès au site
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Le Site est accessible gratuitement à tout utilisateur disposant d'un accès à Internet. Tous les coûts afférents à l'accès au Site, que ce soient les frais matériels, logiciels ou d'accès à Internet, sont exclusivement à la charge de l'utilisateur.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical met en œuvre tous les moyens raisonnables à sa disposition pour assurer un accès de qualité au Site, mais n'est tenue à aucune obligation d'y parvenir.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical ne peut être tenue responsable de tout dysfonctionnement du réseau ou des serveurs ou de tout autre événement échappant au contrôle raisonnable, qui empêcherait ou dégraderait l'accès au Site.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical se réserve le droit d'interrompre, de suspendre momentanément ou de modifier sans préavis l'accès à tout ou partie du Site, afin d'en assurer la maintenance, ou pour toute autre raison, sans que l'interruption n'ouvre droit à aucune obligation ni indemnisation.
                  </p>
                </div>
              </div>

              {/* Utilisation du site */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-user-settings-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Utilisation du site
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed mb-4">
                    L'utilisateur s'engage à utiliser le Site de manière loyale et conforme à sa destination. Il est notamment interdit :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-close-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      D'utiliser le Site à des fins illégales ou non autorisées
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-close-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      De tenter d'accéder de manière non autorisée au Site ou aux systèmes informatiques
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-close-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      D'introduire des virus, chevaux de Troie ou tout autre code malveillant
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-close-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      De collecter ou stocker des données personnelles d'autres utilisateurs
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-close-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      De reproduire, copier, vendre ou exploiter le Site à des fins commerciales
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-close-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      De porter atteinte aux droits de propriété intellectuelle de SARL ADF Biomédical
                    </li>
                  </ul>
                </div>
              </div>

              {/* Propriété intellectuelle */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-copyright-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Propriété intellectuelle
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    L'ensemble des éléments du Site (structure, textes, images, graphismes, logos, icônes, sons, logiciels, etc.) est la propriété exclusive de SARL ADF Biomédical ou de ses partenaires et est protégé par les lois algériennes et internationales relatives à la propriété intellectuelle.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du Site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de SARL ADF Biomédical.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Toute exploitation non autorisée du Site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions légales en vigueur.
                  </p>
                </div>
              </div>

              {/* Responsabilité */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-shield-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Limitation de responsabilité
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur le Site, dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Toutefois, SARL ADF Biomédical ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur le Site.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    En conséquence, SARL ADF Biomédical décline toute responsabilité pour :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le Site
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Tout dommage résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      Tout dommage direct ou indirect causé à l'utilisateur lors de l'accès au Site
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      L'utilisation du Site par l'utilisateur ou toute personne accédant au Site via son équipement
                    </li>
                  </ul>
                </div>
              </div>

              {/* Liens hypertextes */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-links-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Liens hypertextes
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Le Site peut contenir des liens hypertextes vers d'autres sites présents sur le réseau Internet. Les liens vers ces autres ressources vous font quitter le Site.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical ne dispose d'aucun moyen pour contrôler les sites en connexion avec le Site et ne répond pas de la disponibilité de tels sites et sources externes, ni ne la garantit. Elle ne peut être tenue pour responsable de tout dommage, de quelque nature que ce soit, résultant du contenu de ces sites ou sources externes.
                  </p>
                </div>
              </div>

              {/* Données personnelles */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-shield-user-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Protection des données personnelles
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Les informations personnelles collectées sur le Site sont traitées conformément à notre <Link to="/legal/politique-confidentialite" className="text-[#E31B23] hover:underline cursor-pointer">Politique de confidentialité</Link>.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Conformément à la loi algérienne n° 18-07 du 10 juin 2018 relative à la protection des personnes physiques dans le traitement des données à caractère personnel et au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                  </p>
                </div>
              </div>

              {/* Modification des CGU */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-refresh-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Modification des CGU
                </h3>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical se réserve le droit de modifier les présentes CGU à tout moment. Les CGU modifiées seront publiées sur le Site avec une nouvelle date de mise à jour. Il est donc conseillé à l'utilisateur de consulter régulièrement les CGU. L'utilisation du Site après modification des CGU vaut acceptation des nouvelles CGU.
                  </p>
                </div>
              </div>

              {/* Droit applicable */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-scales-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Droit applicable et juridiction
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Les présentes CGU sont régies par le droit algérien. Tout litige relatif à l'interprétation ou à l'exécution des présentes CGU sera soumis à la compétence exclusive des tribunaux algériens.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    En cas de litige, les parties s'efforceront de trouver une solution amiable avant toute action judiciaire.
                  </p>
                </div>
              </div>

              {/* Contact */}
              <div className="bg-gradient-to-r from-[#E31B23] to-[#C41820] rounded-2xl p-12 text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-white/20 rounded-full">
                  <i className="ri-question-line text-5xl text-white"></i>
                </div>
                <h4 className="text-3xl font-bold text-white mb-4">Questions sur les conditions d'utilisation ?</h4>
                <p className="text-lg text-white/90 mb-8">
                  Notre équipe est à votre disposition pour répondre à toutes vos questions
                </p>
                <Link
                  to="/contact"
                  className="inline-block px-10 py-4 bg-white text-[#E31B23] rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
                >
                  Nous contacter
                </Link>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ConditionsUtilisationPage;
